import {useCallback, useState} from "react";
import {loadStripe} from "@stripe/stripe-js";
import config from "../app/config";
import {useCreateSetupIntentMutation} from "../api/rtkQueryApi/BusinessesApi";
export const stripePromise = loadStripe(config.stripe.publishableKey);

export interface IUserPaymentProvider {
    createSetupIntent: (businessId: string) => Promise<string>;
    setSecret: (clientSecret: string) => void;
    clientSecret?: string;
}

export const usePaymentProvider = () => {
    const [createSetupIntent] = useCreateSetupIntentMutation();

    const OnCreateSetupIntent = useCallback(async (businessId: string) => {
        const response = await createSetupIntent({businessId: businessId});
        if (response.data) {
            setResult(prevResult => ({
                ...prevResult,
                clientSecret: response.data.clientSecret
            }));
            return response.data.setupIntentId;
        }
        return '';
    }, [createSetupIntent]);

    const setSecret = (clientSecret: string) => {
        setResult(prevResult => ({
            ...prevResult,
            clientSecret: clientSecret
        }));
    }

    const [result, setResult] = useState<IUserPaymentProvider>({
        createSetupIntent: OnCreateSetupIntent,
        setSecret: setSecret
    })

    return result;
}